import * as React from 'react';
import { createContext, useMemo } from 'react';
import { type IDelegationData } from '../DelegationLogic.ts';

export interface IDelegationContext {
  delegationData?: IDelegationData;
  mainApplicant?: NonNullable<IDelegationData['applicant']>[number];
}

export const DelegationContext = createContext<IDelegationContext | undefined>(
  undefined,
);

export interface IDelegationProviderProps {
  delegationData?: IDelegationData;
  children?: React.ReactNode;
}

/**
 * Context per avere a disposizione le informazioni sulla delega
 */
export function DelegationContextProvider(props: IDelegationProviderProps) {
  const { delegationData } = props;
  const value = useMemo(
    () => ({
      delegationData,
      mainApplicant: delegationData?.applicant?.find(a => a.isMain),
    }),
    [delegationData],
  );
  return (
    <DelegationContext.Provider value={value}>
      {props.children}
    </DelegationContext.Provider>
  );
}

/**
 * È nullo al di fuori della compilazione (es. richiesta inviata,
 * backoffice)
 */
export const useDelegationContext = () => {
  const context = React.useContext(DelegationContext);
  if (!context) {
    return null;
  }
  return context;
};
